// extracted by mini-css-extract-plugin
export var screen = "Layout-module--screen--drD11";
export var grid = "Layout-module--grid--3xwXA";
export var fullContainer = "Layout-module--fullContainer--3MF6i";
export var fullWidth = "Layout-module--fullWidth--2JSPG";